export const ContentBaseTemplateLabelMap = {
    STANDARD: "Expert Content",
    CUSTOM: "Organization Content",
    BASIC: "Basic Content"
}

export const ContentBaseTemplateLabelMixin = {
    data() {
        return {
            ContentBaseTemplateLabels: ContentBaseTemplateLabelMap
        }
    }
}